module.exports = __webpack_public_path__ + "img/gallery-slash.165dae48.svg";